const CompanyList = () => import('Views/company/company-list');
const CompanyAddEdit = () => import('Views/company/company-addEdit');
const CompanyDetail = () => import('Views/company/company-detail');
const CompanyJcAccountAddEdit = () => import('Views/company/company-jc-account-addEdit');
const CompanyPushApiAddEdit = () => import('Views/company/company-push-api-addEdit');
const CompanySmsRechargeList = () => import('Views/company/company-sms-recharge-list');
const CompanySmsRechargeAdd = () => import('Views/company/company-sms-recharge-add');
const CompanyVoiceRechargeList = () => import('Views/company/company-voice-recharge-list');
const CompanyVoiceRechargeAdd = () => import('Views/company/company-voice-recharge-add');

export default[
  { path: '/company-list', component: CompanyList },
  { path: '/company-add', component: CompanyAddEdit },
  { path: '/company-edit/:id', component: CompanyAddEdit },
  { path: '/company-detail/:id', component: CompanyDetail },
  { path: '/company-jc-account-edit/:id', component: CompanyJcAccountAddEdit },
  { path: '/company-push-api-edit/:id', component: CompanyPushApiAddEdit },
  { path: '/company-sms-recharge-list', component: CompanySmsRechargeList },
  { path: '/company-sms-recharge-add', component: CompanySmsRechargeAdd },
  { path: '/company-voice-recharge-list', component: CompanyVoiceRechargeList },
  { path: '/company-voice-recharge-add', component: CompanyVoiceRechargeAdd },
];



// WEBPACK FOOTER //
// ./src/router/company.js